import script from "./SwitchField.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchField.vue?vue&type=script&setup=true&lang=js"

import "./SwitchField.vue?vue&type=style&index=0&id=3340d0e2&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3340d0e2"]])

export default __exports__